@if (pricePerTraveler) {
  <img src="/assets/icons/warning.svg" alt="warning" width="20" height="20" />

  <p class="semi-bold">Keep your protection on this trip</p>

  <div></div>

  <p>
    You already purchased {{ ancillaryTitles[type || ''] }}. Pay the
    {{ pricePerTraveler || 0 | portalCurrency }} difference to stay fully covered on your updated
    flight.
  </p>
} @else {
  <img src="/assets/icons/info-blue.svg" alt="info-blue" width="20" height="20" />
  <p class="semi-bold">You’re still fully covered</p>

  <div></div>

  <p>
    Good news — your protection remains active and there’s nothing more to pay. You can still
    upgrade to the full bundle for even more trip coverage.
  </p>
}
